import { CircularProgress } from "@mui/material";

function Loading() {
  return (
    <div
      style={{
        paddingTop: "10%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </div>
  );
}
export default Loading;
